import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Can } from './abilities-context';
import { withApi, showIfAuthenticated } from './Providers/WebServiceProvider.js';

import logo from './assets/images/tovertaal_logo@2x.png';

import DownloadResourcesButton from './Components/DownloadResourcesButton.js';
import UserProfileButton from './Components/UserProfileButton.js';
import LogoutButton from './Components/LogoutButton.js';

class Topbar extends Component
{
  constructor(props) {
    super(props);
  }

  render() {
    const loggedUser = this.props.webServiceContext.auth.getUser();

    return (
      <nav className="navbar" aria-label="main navigation">
        <div className="navbar-brand">
          <NavLink exact className="navbar-item tovertaal-logo" to="/">
            <figure className="image" style={{ width: 140, height: 55 }}>
              <img src={logo} alt="Tovertaal: Localisation System" width="140" height="55" />
            </figure>
          </NavLink>
        </div>
        <div className="navbar-menu">
          <div className="navbar-start">
            <div className="navbar-item">
              <Can I="update" a="master">
                <NavLink to="/upload">
                  <button className="button is-primary is-outlined">
                    Upload Master
                  </button>
                </NavLink>
              </Can>
            </div>
            <div className="navbar-item">
              <Can I="update" a="master">
                <NavLink to="/master">
                  <button className="button is-primary is-outlined">
                    Edit Master
                  </button>
                </NavLink>
              </Can>
            </div>
            <div className="navbar-item">
              <Can I="update" a="master">
                <DownloadResourcesButton />
              </Can>
            </div>
            <div className="navbar-item">
              <Can I="update" a="locales">
                <NavLink to="/locales">
                  <button className="button is-primary is-outlined">
                    Edit Languages
                  </button>
                </NavLink>
              </Can>
            </div>
            <div className="navbar-item">
              <Can I="manage" a="all">
                <NavLink to="/users">
                  <button className="button is-primary is-outlined">
                    Edit Users
                  </button>
                </NavLink> 
              </Can>
            </div>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <UserProfileButton forceModal={!loggedUser.getFirstname() || !loggedUser.getLastname()} />
              <div className="logout-container">
                <LogoutButton />
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default withApi(showIfAuthenticated(Topbar));


// WEBPACK FOOTER //
// ./src/Topbar.js